import { Button } from "@workspace/ui/components/button";
import { GlassPanel } from "@workspace/ui/components/glass-panel";
import { Input } from "@workspace/ui/components/input";
import { LockKeyhole, LoaderCircle } from "lucide-react";
import { useState } from "react";

import { useSession } from "../lib/dajia-session";
export default function Login() {
	const { signIn } = useSession();
	const [username, setUsername] = useState(
			new URLSearchParams(window.location.search).get("username") ?? "",
		),
		[password, setPassword] = useState(""),
		[busy, setBusy] = useState(false),
		[error, setError] = useState("");
	const submit = async () => {
		setBusy(true);
		setError("");
		try {
			await signIn(username.trim(), password);
			setPassword("");
		} catch (e) {
			setError(e instanceof Error ? e.message : "登录未完成，请重试。");
		} finally {
			setBusy(false);
		}
	};
	return (
		<main className="mx-auto grid min-h-[80vh] max-w-lg items-center px-5 py-10">
			<GlassPanel className="space-y-7 p-7 sm:p-10">
				<div className="space-y-3">
					<div className="grid size-12 place-items-center rounded-xl bg-primary/10 text-primary">
						<LockKeyhole />
					</div>
					<p className="text-sm text-primary">GEO 品牌监测</p>
					<h1 className="text-2xl font-semibold">账号登录</h1>
					<p className="text-sm leading-7 text-muted-foreground">
						使用所属单位的账号登录，查看本单位监测数据与报告。
					</p>
					<div className="flex gap-2 text-xs text-muted-foreground">
						<span className="rounded-md border px-3 py-1">
							大家保险及子公司
						</span>
						<span className="rounded-md border px-3 py-1">大家的家</span>
					</div>
				</div>
				<form
					className="space-y-5"
					onSubmit={(e) => {
						e.preventDefault();
						void submit();
					}}
				>
					<label className="grid gap-2 text-sm font-medium">
						账号
						<Input
							aria-label="账号"
							autoComplete="username"
							value={username}
							onChange={(e) => setUsername(e.target.value)}
							maxLength={64}
							required
							disabled={busy}
						/>
					</label>
					<label className="grid gap-2 text-sm font-medium">
						密码
						<Input
							aria-label="密码"
							type="password"
							autoComplete="current-password"
							value={password}
							onChange={(e) => setPassword(e.target.value)}
							maxLength={128}
							required
							disabled={busy}
						/>
					</label>
					{error && (
						<p role="alert" className="text-sm leading-6 text-destructive">
							{error}
						</p>
					)}
					<Button type="submit" className="w-full" disabled={busy}>
						{busy && <LoaderCircle className="animate-spin" />}
						{busy ? "正在登录…" : "登录"}
					</Button>
				</form>
			</GlassPanel>
		</main>
	);
}
